import React, { useState } from 'react';
import { Box, VStack, Flex, Icon, Text, Collapse } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
import {
  FaHome,
  FaBox,
  FaUsers,
  FaTruck,
  FaFileInvoice,
  FaBars,
  FaTags,
  FaAngleDown,
  FaAngleUp,
  FaPrint
} from 'react-icons/fa';

const Sidebar = ({ isExpanded, setIsExpanded }) => {
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);

  const toggleSidebar = () => setIsExpanded(!isExpanded);
  const toggleInvoiceMenu = () => setIsInvoiceOpen(!isInvoiceOpen);

  return (
    <Box
      bg="primary.500"
      color="white"
      w={isExpanded ? "200px" : "80px"}
      h="100vh"
      pt="5"
      position="fixed"
      top="0"
      left="0"
      transition="width 0.3s ease"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <VStack align="stretch" spacing="0" mt="10">
        <NavLink
          to="/"
          style={({ isActive }) => ({
            backgroundColor: isActive ? '#142c4d' : 'transparent',
          })}
        >
          <Box p="5" _hover={{ bg: 'primary.600' }}>
            <Flex align="center">
              <Icon as={FaHome} boxSize="5" />
              <Text ml="4" display={isExpanded ? "block" : "none"}>Борда</Text>
            </Flex>
          </Box>
        </NavLink>

        <NavLink to="/categories" style={({ isActive }) => ({ backgroundColor: isActive ? '#142c4d' : 'transparent' })}>
          <Box p="5" _hover={{ bg: 'primary.600' }}>
            <Flex align="center">
              <Icon as={FaTags} boxSize="5" />
              <Text ml="4" display={isExpanded ? "block" : "none"}>Категорії</Text>
            </Flex>
          </Box>
        </NavLink>

        <NavLink to="/products" style={({ isActive }) => ({ backgroundColor: isActive ? '#142c4d' : 'transparent' })}>
          <Box p="5" _hover={{ bg: 'primary.600' }}>
            <Flex align="center">
              <Icon as={FaBox} boxSize="5" />
              <Text ml="4" display={isExpanded ? "block" : "none"}>Товар</Text>
            </Flex>
          </Box>
        </NavLink>

        <NavLink to="/customers" style={({ isActive }) => ({ backgroundColor: isActive ? '#142c4d' : 'transparent' })}>
          <Box p="5" _hover={{ bg: 'primary.600' }}>
            <Flex align="center">
              <Icon as={FaUsers} boxSize="5" />
              <Text ml="4" display={isExpanded ? "block" : "none"}>Покупці</Text>
            </Flex>
          </Box>
        </NavLink>

        <NavLink to="/suppliers" style={({ isActive }) => ({ backgroundColor: isActive ? '#142c4d' : 'transparent' })}>
          <Box p="5" _hover={{ bg: 'primary.600' }}>
            <Flex align="center">
              <Icon as={FaTruck} boxSize="5" />
              <Text ml="4" display={isExpanded ? "block" : "none"}>Постачальники</Text>
            </Flex>
          </Box>
        </NavLink>

        <Box p="5" cursor="pointer" onClick={toggleInvoiceMenu} _hover={{ bg: 'primary.600' }}>
          <Flex align="center" justify="space-between">
            <Flex align="center">
              <Icon as={FaFileInvoice} boxSize="5" />
              <Text ml="4" display={isExpanded ? 'block' : 'none'}>
                Накладні
              </Text>
            </Flex>
            <Icon as={isInvoiceOpen ? FaAngleUp : FaAngleDown} display={isExpanded ? 'block' : 'none'} />
          </Flex>
        </Box>
        <Collapse in={isInvoiceOpen} animateOpacity>
          <Box pl="8" display={isExpanded ? 'block' : 'none'}>
            <NavLink to="/sell-invoices" style={({ isActive }) => ({ color: isActive ? '#ffffff' : '#a0aec0' })}>
              <Text py="2" _hover={{ color: '#ffffff' }}>Продаж</Text>
            </NavLink>
            <NavLink to="/arrival-invoices" style={({ isActive }) => ({ color: isActive ? '#ffffff' : '#a0aec0' })}>
              <Text py="2" _hover={{ color: '#ffffff' }}>Прихід</Text>
            </NavLink>
            <NavLink to="/return-invoices" style={({ isActive }) => ({ color: isActive ? '#ffffff' : '#a0aec0' })}>
              <Text py="2" _hover={{ color: '#ffffff' }}>Повернення</Text>
            </NavLink>
          </Box>
        </Collapse>
      </VStack>

      {/* Print product card link at the bottom */}
      <Box>
        <NavLink
          to="/print-product-cards"
          style={({ isActive }) => ({
            backgroundColor: isActive ? '#142c4d' : 'transparent',
          })}
        >
          <Box p="5" _hover={{ bg: 'primary.600' }}>
            <Flex align="center">
              <Icon as={FaPrint} boxSize="5" />
              <Text ml="4" display={isExpanded ? "block" : "none"}>Друк карток</Text>
            </Flex>
          </Box>
        </NavLink>
      </Box>

      {/* Toggle Button */}
      <Box
        onClick={toggleSidebar}
        position="absolute"
        bottom="20"
        right={isExpanded ? "-15px" : "-20px"}
        bg="primary.600"
        p="2"
        cursor="pointer"
        borderRadius="md"
        _hover={{ bg: "primary.700" }}
        color="white"
      >
        <Icon as={FaBars} />
      </Box>
    </Box>
  );
};

export default Sidebar;